<!-- 
Panel for displaying a levy collection's invoice payment details.
-->
<template>
  <div>
    <our-data-container>
      <our-data-field label="BPAY biller code" label-width="3">{{ configuration.bpayBillerCode }}</our-data-field>
      <our-data-field label="Account BSB" label-width="3">{{ configuration.accountBsb }}</our-data-field>
      <our-data-field label="Account number" label-width="3">{{ configuration.accountNumber }}</our-data-field>
      <our-data-field label="Account name" label-width="3">{{ configuration.accountName }}</our-data-field>
    </our-data-container>
    <div class="text-xs-center py-2">
      <v-btn v-if="canEdit" @click="showEditDialog=true">
        <v-icon class="mr-2">edit</v-icon>
        Edit
      </v-btn>
    </div>
    <invoice-payment-details-configuration-dialog v-model="showEditDialog" :levy-collection-id="levyCollectionId" />
  </div>
</template>

<script>
import lookupMixins from "@/mixins/lookup.mixins";
import filterMixins from "@/mixins/filter.mixins";
import * as claim from "@/store/claim-types";
import * as action from "@/store/levy-collections/action-types";
import InvoicePaymentDetailsConfigurationDialog from "@/components/levy-collection-setup/InvoicePaymentDetailsConfigurationDialog.vue";

export default {
  components: { InvoicePaymentDetailsConfigurationDialog },
  mixins: [lookupMixins, filterMixins],
  props: {
    levyCollectionId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      showEditDialog: false
    };
  },
  computed: {
    state() {
      return this.$store.state.levyCollections.viewInvoiceConfiguration;
    },
    loaded() {
      return this.state.loaded;
    },
    configuration() {
      return this.state.data;
    },
    canEdit() {
      const hasPermission = this.$store.getters.claims.includes(claim.LEVY_COLLECTION_CONFIGURE_INVOICE);
      const isAllowableStatus = this.doesLookupHaveAttribute(
        this.configuration.status,
        "CanEditInvoicePaymentDetailsConfiguration",
        this.lookups.levyCollectionStatuses
      );
      return hasPermission && isAllowableStatus;
    }
  },
  watch: {
    levyCollectionId() {
      this.refresh();
    },
    loaded() {
      this.refresh();
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      const needsReloaded =
        (!this.state.loaded && !this.state.loading) || this.state.levyCollectionId != this.levyCollectionId;
      if (needsReloaded) {
        this.$store.dispatch(action.VIEW_INVOICE_CONFIGURATION, this.levyCollectionId);
      }
    }
  }
};
</script>
